/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { useCampaignsList } from '@api/hooks';

import SearchableEntitySelect from '../SearchableEntitySelect';

const CampaignSelect = ({ placeholder = 'Type the name of campaign...', ...props }) => (
  <SearchableEntitySelect placeholder={placeholder} useList={useCampaignsList} {...props} />
);

export default CampaignSelect;
